import styled from "styled-components";
import { FontProsp, WrapperProsp } from "./types";

export const TitleWrapper = styled.div<WrapperProsp>`
  margin: ${({ margin }) => (margin ? margin : "20px 0")};
  display: flex;
  position: relative;
  z-index: 11;
  height: ${({ height }) => (height ? height : null)};
  width: ${({ width }) => (width ? width : null)};
  flex-direction: column;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : "center")};
  padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : null)};

  @media (max-width: 768px) {
    padding-left: 0;
  }

  @media (max-width: 550px) {
    padding-left: 0;
    text-align: center;
    align-items: center;
  }
`;

export const Title = styled.h1<FontProsp>`
  font-size: ${({ font }) => (font ? font : `36px`)};
  color: ${({ color }) => (color ? color : "black")};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : null)};
  font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : null)};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : null)};
  font-style: ${({ fontStyle }) => (fontStyle ? fontStyle : null)};
  display: flex;
  flex-wrap: wrap;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : null)};

  @media (max-width: 992px) {
    font-size: ${({ font }) => {
      if (font && typeof font === "string") {
        if (font.includes("rem")) {
          const num = parseFloat(font);
          return `${Math.max(num * 0.9, 1.3)}rem`;
        }
        if (font.includes("px")) {
          const num = parseFloat(font);
          return `${Math.max(num * 0.9, 26)}px`;
        }
      }
      return font || "30px";
    }};
  }

  @media (max-width: 768px) {
    font-size: ${({ font }) => {
      if (font && typeof font === "string") {
        if (font.includes("rem")) {
          const num = parseFloat(font);
          return `${Math.max(num * 0.8, 1.2)}rem`;
        }
        if (font.includes("px")) {
          const num = parseFloat(font);
          return `${Math.max(num * 0.8, 24)}px`;
        }
      }
      return font || "28px";
    }};
  }

  @media (max-width: 550px) {
    font-size: ${({ font }) => {
      if (font && typeof font === "string") {
        if (font.includes("rem")) {
          const num = parseFloat(font);
          return `${Math.max(num * 0.7, 1.1)}rem`;
        }
        if (font.includes("px")) {
          const num = parseFloat(font);
          return `${Math.max(num * 0.7, 20)}px`;
        }
      }
      return font || "22px";
    }};
  }

  @media (max-width: 400px) {
    font-size: ${({ font }) => {
      if (font && typeof font === "string") {
        if (font.includes("rem")) {
          const num = parseFloat(font);
          return `${Math.max(num * 0.6, 1)}rem`;
        }
        if (font.includes("px")) {
          const num = parseFloat(font);
          return `${Math.max(num * 0.6, 18)}px`;
        }
      }
      return font || "20px";
    }};
  }
`;

export const Subtitles = styled.p<FontProsp>`
  font-size: ${({ font }) => (font ? font : null)};
  color: ${({ color }) => (color ? color : "black")};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : null)};
  font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : null)};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : null)};
  font-style: ${({ fontStyle }) => (fontStyle ? fontStyle : null)};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing ? letterSpacing : null};
  display: flex;
  flex-wrap: wrap;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : null)};
  padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : null)};

  @media (max-width: 768px) {
    font-size: ${({ font }) => {
      if (font && typeof font === "string") {
        if (font.includes("px")) {
          const num = parseFloat(font);
          if (num > 14) {
            return `${Math.max(num * 0.95, 14)}px`;
          }
        }
      }
      return font;
    }};
    letter-spacing: ${({ letterSpacing }) => {
      if (
        letterSpacing &&
        typeof letterSpacing === "string" &&
        letterSpacing.includes("px")
      ) {
        const num = parseFloat(letterSpacing);
        return `${Math.max(num * 0.8, 1)}px`;
      }
      return letterSpacing;
    }};
    padding-left: 0;
  }

  @media (max-width: 600px) {
    font-size: ${({ font }) => {
      if (font && typeof font === "string") {
        if (font.includes("px")) {
          const num = parseFloat(font);
          if (num > 14) {
            return `${Math.max(num * 0.875, 13)}px`;
          }
        }
      }
      return font;
    }};
    letter-spacing: ${({ letterSpacing }) => {
      if (
        letterSpacing &&
        typeof letterSpacing === "string" &&
        letterSpacing.includes("px")
      ) {
        const num = parseFloat(letterSpacing);
        return `${Math.max(num * 0.7, 1)}px`;
      }
      return letterSpacing;
    }};
  }

  @media (max-width: 400px) {
    font-size: ${({ font }) => {
      if (font && typeof font === "string") {
        if (font.includes("px")) {
          const num = parseFloat(font);
          if (num > 13) {
            return `${Math.max(num * 0.8, 12)}px`;
          }
        }
      }
      return font;
    }};
  }
`;

export const StyledText = styled.h4<FontProsp>`
  font-size: ${({ font }) => (font ? font : null)};
  color: ${({ color }) => (color ? color : "black")};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : null)};
  font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : null)};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : null)};
  font-style: ${({ fontStyle }) => (fontStyle ? fontStyle : null)};
`;
